// prettier-ignore
export default {
  "generic": {
    "network_error": "Não é possível conectar.<br>Por favor, verifique sua conexão com a Internet.",
    "network_restored": "A conexão com a Internet foi restaurada."
  },
  "login": {
    "cloudzet_welcome": "Olá, Bem-vindo ao Cloudzet",
    "mtm_username": "Conta Scanatic™",
    "password": "Senha",
    "login": "Entrar",
    "logging_in": "Fazendo login...",
    "no_login_methods": "Nenhum método de login definido para esta conta Scanatic™",
    "agreements_button": "Concordar e continuar",
    "complete_email_reset_pwd_title": "Estamos aqui para te apoiar!",
    "sent_email": "Enviamos um e-mail para",
    "email_reset_pwd": "Por favor, siga a instrução para redefinir a senha",
    "get_the_code": "Não recebeu o código?",
    "resend": "Reenviar",
    "complete_phone_reset_pwd_title": "Parabéns!",
    "login_new_password": "A nova senha foi definida,<br />por favor, faça login com a nova senha",
    "login_my_account": "Acessar minha conta",
    "sent_a_code": "Acabamos de enviar um código para",
    "received_code": "Me avise se você o recebeu",
    "verification_code_error": "Erro no código de verificação",
    "continue": "Continuar",
    "forget_your_password": "Esqueceu sua senha?",
    "forget_password_text": "Não se preocupe!",
    "send": "Enviar",
    "submit": "Enviar",
    "no_such_user": "Conta não encontrada",
    "email_prompt_text": "Enviaremos um e-mail para redefinir sua senha",
    "phone_prompt_text": "Enviaremos um código de verificação de 4 dígitos",
    "login_title": "Bem-vindo de volta!",
    "login_email_title": "Entrar com Email",
    "login_phone_title": "Entrar com Telefone",
    "forget_password": "Esqueceu a Senha?",
    "terms_of_service": "Nossos termos de serviço",
    "choose_a_country_code": "Escolha um código de país",
    "choose_a_country_code_hint": "Login/registro está disponível apenas nos seguintes países e regiões.",
    "country_code_not_found": "Não conseguiu encontrar seu código de país?",
    "sign_up_email": "Cadastre-se com e-mail",
    "email_sign_up_error_msg": "Por favor, insira o e-mail correto",
    "four_characters": "Sua senha deve ter pelo menos 4 caracteres",
    "try_to_login": "Esta conta já existe. Tente fazer login",
    "try_use_email": "Tente usar seu e-mail",
    "sign_up": "Inscrever-se",
    "sent_verification_code": "Enviaremos um código de verificação de 4 dígitos.",
    "sign_up_phone": "Cadastre-se com Telefone",
    "sign_up_store": "Cadastre-se com loja",
    "set_up_new_pwd": "Agora, defina uma nova senha",
    "set_up_new_password": "Agora, você pode definir<br> sua nova senha",
    "set_new_pwd": "Definir nova senha",
    "enter_country_code": "Insira o código do país",
    "enter_email_address": "Insira seu endereço de e-mail",
    "enter_phone_number": "Insira seu Número de Telefone",
    "customer_account_name": "Nome da conta do cliente",
    "enter_password": "Insira a senha",
    "re_enter_password": "Reinsira a senha",
    "login_social_accounts": "Cadastre-se com conta social",
    "social_login_failed": "Falha ao fazer login com conta social",
    "login_first": "Por favor, faça login primeiro",
    "create_with_store": "Criar com loja",
    "verify": "Verificar",
    "welcome_to_store": "Bem-vindo à {storeName}!",
    "login_to_continue": "Login/Cadastre-se para continuar",
    "wrong_password": "Senha incorreta. Por favor, insira novamente.",
    "get_the_email": "Não recebeu o e-mail?"
  },
  "welcome": {
    "enable_bt": "Senha incorreta. Insira novamente.",
    "welcome_title": "Bem-vindo à<br> Sala de Escaneamento 3D.",
    "powered_by": "Feito por TG3D Studio Inc.",
    "tap_to_start": "Toque na bolha para iniciar",
    "tap_camera_on": "Ligue a câmera para escanear o código QR",
    "ready_to_scan_qr": "Pronto para Escanear Código QR",
    "note_front_camera": "Observe que a câmera frontal será usada ao escanear o Código QR",
    "scan_code_title": "Escanear Código QR para Começar",
    "scan_code_hint": "Por favor, coloque o código QR na caixa",
    "scan_code_processing": "Processando...",
    "scan_code_logging_in": "Fazendo login na sua conta...",
    "scan_code_connect_to_scanner": "Conectando ao scanner...",
    "scan_code_no_account": "Conta não existe. Por favor, tente novamente.",
    "scan_code_done": "Pronto para começar!",
    "no_scanner_id": "Nenhum ID de scanner configurado para esta conta Scanatic™",
    "no_scanner_found": "Scanner especificado não encontrado",
    "scanner_in_use": "O scanner está sendo usado",
    "unexpected_error": "Algo deu errado :(",
    "need_camera_permission": "Você deve conceder permissão de câmera para usar este recurso",
    "share_qr_code": "Mostrar meu QR code",
    "my_qr_code": "Meu QR code",
    "scan_qr_code_reminder": "Você estará conectado a outros dispositivos quando escanear o QR code."
  },
  "choose": {
    "step_name": "Prepare-se para o Escaneamento Corporal 3D",
    "step_info": "Quando estiver pronto,<br>levante os punhos para dentro das bolhas",
    "tutorial": "Tutorial",
    "start_scan": "Escaneamento 3D",
    "clench_fingers": "Feche levemente os dedos",
    "raise_arm": "Levante seu braço até tocar na bolha",
    "hold_til_fill": "Agora segure até que a bolha esteja preenchida"
  },
  "thingstonote": {
    "title": "Antes do Escaneamento Corporal 3D",
    "wear_tight": "Use roupas justas e modeladas ao corpo",
    "tie_hair": "Prenda seu cabelo para mostrar a parte de trás do seu pescoço",
    "remove_acc": "Remova todos os seus acessórios"
  },
  "scanscreen": {
    "skip": "Pular"
  },
  "tutorial": {
    "title": "Tutorial de Controle Sem Contato",
    "contactless": "A experiência sem contato garante que sua saúde seja protegida",
    "clench_fingers": "Feche levemente os dedos",
    "raise_arm": "Para controlar as bolhas, por favor, levante os braços até tocar nas bolhas e segure por 2 segundos",
    "hold": "Agora segure até que a bolha esteja preenchida",
    "proceed": "Para prosseguir para o próximo passo, levante seu braço direito até que ele toque na bolha.",
    "return": "Para retornar ao passo anterior, levante seu braço esquerdo até que ele toque na bolha.",
    "feet_pos": "Posicione seus pés no tapete no chão"
  },
  "scan": {
    "feet_pos": "Posicione seus pés no tapete no chão",
    "step_name": "Escaneamento Corporal 3D",
    "phase_one_done": "Fase 1 concluída",
    "begin_2nd": "Inicie o Escaneamento Corporal 3D na 2ª Pose",
    "clench": "Feche levemente os dedos",
    "raise_both_arm": "Levante os braços lentamente e segure seus punhos nas bolhas",
    "raise_fists": "Levante seus punhos e segure-os nas bolhas",
    "lower_fists": "Abaixe seus punhos e segure-os nas bolhas",
    "hold_still": "Mantenha seus braços imóveis",
    "scan_keep_still": "Mantenha seu corpo imóvel",
    "scan_in_progress": "Escaneamento em andamento",
    "scan_complete": "Escaneamento concluído. <br>Você pode relaxar seu corpo.",
    "two_step_scan": "O escaneamento será conduzido em 2 fases",
    "scanner_occupied": "Sala de escaneamento ocupada. Por favor, contate a equipe para reconfigurar o scanner e tentar novamente.",
    "scanner_error_need_reset": "Erro no scanner. Por favor, contate a equipe para reconfigurar o scanner e tentar novamente.",
    "scanner_error_generic": "Erro no scanner. Por favor, contate a equipe.",
    "scanner_not_activated": "Scanner não ativado. Por favor, contate a equipe.",
    "scanner_check_network": "Por favor, contate a equipe para verificar se o scanner está conectado à internet ou reconfigurar o scanner e tentar novamente."
  },
  "handles": {
    "hold": "Segure os cabos.<br>Braços relaxados e esticados",
    "hold_ready": "Segure os cabos.<br>Você está pronto agora",
    "letgo_and_keep_feet": "Solte os cabos e mantenha seus pés nas marcas no chão",
    "clench_ipose": "Punhos levemente cerrados, mãos a cerca de 5 cm (2 polegadas) de distância do corpo",
    "clench_ready": "Punhos levemente cerrados, Você está pronto agora"
  },
  "end": {
    "thank": "Obrigado!",
    "belonging": "Por favor, lembre-se de levar seus pertences pessoais com você."
  },
  "analyzing": {
    "check_err": "Criando o avatar 3D..."
  },
  "result": {
    "scan_successful": "Ótimo trabalho!<br>Seu escaneamento 3D foi bem-sucedido",
    "scan_unsuccessful": "Não conseguimos processar seus dados",
    "avoid_errors": "Causas Comuns de Erros de Escaneamento",
    "error_accessories": "Usando acessórios",
    "error_cover_neck": "Cabelo cobrindo seu pescoço",
    "error_floor_marks": "Pés em posição errada",
    "error_postural": "Postura incorreta",
    "leave": "Sair",
    "raise": "Levante os punhos para as bolhas para escanear novamente",
    "scan_again": "Escanear Novamente",
    "analyzing": "Processando seus dados de escaneamento...",
    "click_scan_again": "Clique no botão abaixo para escanear novamente",
    "oops": "Ops!",
    "unexpected_error": "Parece que algo está errado...",
    "close": "Fechar",
    "error_top_loose": "Sua blusa está muito larga",
    "error_bottoms_loose": "Sua calça está muito larga",
    "error_outfit_loose": "Sua roupa está muito larga",
    "scan_error_detected": "Problemas detectados na sua digitalização"
  },
  "measurement": {
    "neck": "Pescoço",
    "chest": "Peito",
    "torso": "Torso",
    "mid_waist": "Cintura Média",
    "hip": "Quadril",
    "shoulder": "Ombro",
    "biceps": "Bíceps",
    "arm": "Braço",
    "thigh": "Coxa",
    "inner_leg": "Parte interna da perna",
    "chest_female": "Busto"
  },
  "homePage": {
    "firstScanTitle": "Comece sua<br/>jornada para o futuro",
    "tap_to_scan": "Toque para Escanear em 3D",
    "measurement": "MEDIÇÃO",
    "body_3d_avatar": "Corporal 3D",
    "see_more": "Veja mais",
    "menu": "Menu",
    "store_settings": "Configurações da loja",
    "avatar_shader_3d": "Shader de Avatar 3D",
    "avatar_shader": "Shader de Avatar",
    "create_3d_shader": "Criar Shader 3D",
    "language": "Idioma",
    "get_help": "Obter ajuda",
    "feedback": "Feedback",
    "send_feedback": "Envie feedback",
    "send_btn": "Enviar",
    "send_feedback_placeholder": "Seu feedback nos ajudará a melhorar nosso produto e serviço",
    "send_feedback_title": "Obrigado pelo seu feedback",
    "send_feedback_content": "Estaremos anotando seu feedback e esperamos oferecer uma experiência melhor no futuro. Por favor, não hesite em falar se tiver mais a dizer!",
    "report_crash": "Reportar um erro",
    "report_crash_title": "Obrigado por nos informar",
    "report_crash_content": "Lamentamos sua experiência. <br>Nossa equipe inspecionará este problema o mais rápido possível. Ao mesmo tempo, por favor, não hesite em entrar em contato se encontrar outros problemas.",
    "rate_app": "Eu amo o App Cloudzet",
    "rate_app_title": "Avalie o App Cloudzet",
    "rate_app_content": "Se você ama nosso app, por favor, tire um momento para avaliar ou revisá-lo na App Store. Obrigado!",
    "login_s4f": "Entrar com <br/> conta Scanatic™",
    "login": "Entrar",
    "password": "Senha",
    "account_settings": "Configurações da conta",
    "enter_Scanatic_account": "Entre com a conta Scanatic™",
    "logout": "Sair",
    "delete_account": "Excluir conta",
    "confirm_delete": "Tem certeza?",
    "contactless_scan": "Escaneamento Sem Contato",
    "delete": "Excluir",
    "cancel_delete": "Cancelar",
    "ok": "Ok",
    "scan_to_login": "Escanear código QR",
    "history": "História",
    "view_avatar": "Visualizar avatar 3D",
    "select_date": "Selecionar a data",
    "select": "Selecionar",
    "analysis": "Análise",
    "comparison": "Comparação",
    "leftCompareView": "Modelo à esquerda",
    "rightCompareView": "Modelo à direita",
    "go_to_app_store": "Ir para a App Store",
    "measure": "Medir",
    "history_tab": "Histórico"
  },
  "sanne": {
    "login_welcome": "Olá, Bem-vindo à Sanne",
    "welcome_title": "Bem-vindo ao the arc.",
    "tap_camera_on": "Toque aqui para ligar a câmera e escanear seu QR Code pessoal",
    "tutorial_remove_acc": "Certifique-se de remover todas as joias e coloque-as neste suporte junto com seu celular durante o escaneamento.",
    "tutorial_step": "PASSO {n} DE {total}",
    "end_hint": "Lembre-se de levar seu celular e suas joias ao sair e feche a porta da sala de escaneamento. Ela será trancada automaticamente.",
    "generating": "Gerando medidas",
    "scan_code_title": "Escaneie seu QR Code",
    "tutorial_wear_tight": "Use roupas justas e ajustadas ao corpo",
    "step_info": "Quando estiver pronto,<br>levante os punhos para dentro das bolhas",
    "feet_pos": "Posicione os pés nas marcações",
    "raise_both_arm": "Levante os braços lentamente e mantenha os punhos nas bolhas",
    "scan_in_progress": "Escaneamento em andamento...",
    "network_error": "Verifique sua conexão com a Internet",
    "enable_bt": "Ative o Bluetooth para procurar scanners próximos",
    "avoid_errors": "Causas comuns de erros de escaneamento",
    "login_s4f": "Entrar com Scanatic™ for Fashion",
    "end_title": "Obrigado!",
    "log_in": "Entrar"
  },
  "settingUserData": {
    "your_birth": "Qual é o seu ano de nascimento?",
    "your_gender": "Diga-me seu gênero",
    "female": "Feminino",
    "male": "Masculino",
    "tall": "Qual é a sua altura?",
    "cm": "Cm",
    "inch": "Inch",
    "your_height": "Altura",
    "your_weight": "Quanto você pesa?",
    "weight": "Peso",
    "lbs": "Lbs",
    "kg": "Kg",
    "nickname": "Seu nome",
    "lets_go": "Vamos lá"
  },
  "profile": {
    "profile": "Perfil",
    "edit_profile": "Editar Perfil",
    "name": "Nome",
    "birthday": "Data de Nascimento",
    "birthyear": "Ano de Nascimento",
    "phone": "Número de Telefone",
    "address": "Endereço",
    "save": "Ok"
  },
  "discovery": {
    "turn_on_bt": "Ligar Bluetooth",
    "turn_on_bt_hint": "Autorizar e ativar o Bluetooth",
    "turn_on_bt_hint_ios": "Certifique-se de que as seguintes configurações foram concluídas:<br>1. Conceder permissão<br>　● Vá para Configurações > Privacidade e segurança > Bluetooth e habilite o acesso para o Cloudzet.<br>2. Ativar Bluetooth<br>　● Vá para Configurações > Bluetooth e ative-o.",
    "turn_on_bt_hint_android": "Certifique-se de que as seguintes configurações foram concluídas:<br>1. Ativar o Bluetooth<br>　● Deslize de cima para baixo na tela e toque em Bluetooth.",
    "searching": "Buscando scanners próximos...",
    "select_scanner": "Selecione uma sala de escaneamento próxima para iniciar",
    "scanner__foot": "Scanner de Pés",
    "scanner__body": "Scanner Corporal",
    "start_scan": "Iniciar Escaneamento 3D",
    "no_scanners": "Não foi possível encontrar nenhum scanner próximo",
    "try_again": "Tente novamente"
  },
  "footscan": {
    "take_off": "Antes do escaneamento 3D, por favor, tire seus sapatos",
    "barefoot": "Use meias justas<br>ou fique descalço",
    "show_ankles": "Dobre as pernas da calça<br>para mostrar seus tornozelos",
    "sit": "Por favor, sente-se com<br>seus joelhos dobrados em um ângulo de 90°",
    "stand_up": "Por favor, levante-se",
    "position_feet": "Posicione seus pés na<br>área marcada no chão",
    "start_scan": "Pronto para escanear",
    "ready_to_scan": "Pronto para começar!",
    "stand_up_for_2nd_scan": "\"Por favor, levante-se e fique de frente para se preparar<br>para o escaneamento\"",
    "stand_still": "Por favor, mantenha seu corpo imóvel<br>e olhe para frente",
    "scan_complete": "Escaneamento concluído<br>Você pode relaxar",
    "creating_3d_foot": "Criando modelo 3D do pé...",
    "scan_successful": "Ótimo trabalho!<br>Seu escaneamento 3D foi bem-sucedido",
    "click_to_rescan": "Clique no botão abaixo<br>para escanear novamente",
    "feet_3d": "Pés 3D",
    "analysis": "Análise de Pé",
    "initial_l": "E",
    "initial_r": "D",
    "tab__fit": "Ajuste de Sapatos",
    "tab__width": "Largura",
    "tab__arches": "Arcos",
    "tab__measure": "Medir",
    "tab__type": "Tipo",
    "shoes_guide": "Guia de tamanho de sapatos",
    "shoes_last": "Forma do seu sapato",
    "measurement__foot_length": "Comprimento",
    "measurement__foot_width": "Largura",
    "measurement__arch": "Arcos",
    "measurement__finger_shape": "Tipo de Pé",
    "arch_type__title": "Seus Arcos de Pé",
    "arch_type__high": "Arco Alto",
    "arch_type__summary_high": "O arco de um pé cavo aparecerá alto mesmo quando em pé. Além disso, um ou mais dos seguintes sintomas podem ser apresentados:",
    "arch_type__desc_high": "• Dedos em martelo (dedos curvados) ou dedos em garra.<br> \n• Calos na bola, lado ou calcanhar do pé.<br> \n• Dor ao ficar em pé ou ao caminhar.<br> \n• Um pé instável devido ao calcanhar inclinando para dentro, o que pode levar a torções no tornozelo.\n\nRecomendação de tipo de sapato: \nAdequado para sapatos que têm alta absorção de choque com amortecimento estruturado. A dureza da sola deve ser de cerca de 45 graus, não muito espessa ou fina. Inserir palmilhas de arco alto proporciona suporte para seus arcos e distribui o peso do corpo uniformemente pelo seu pé, o que diminuirá o impacto em suas pernas.",
    "arch_type__normal": "Arco Normal",
    "arch_type__summary_normal": "Se a parte do meio do seu arco estiver cerca de metade preenchida, isso significa que você tem um arco normal.",
    "arch_type__desc_normal": "Parabéns por ter um arco normal. Continue com sua rotina normal de exercícios e peso. Não há nada com que se preocupar.\n\nRecomendação de tipo de sapato: Você é adequado para todos os tipos de sapatos, já que seu peso corporal é distribuído uniformemente pelo seu pé.",
    "arch_type__low": "Arco Baixo",
    "arch_type__summary_low": "O arco de um pé cavo aparecerá baixo ou plano, o que significa que toda a parte inferior do seu pé toca o chão quando você está em pé. Além disso, um ou mais dos seguintes sintomas podem ser apresentados:",
    "arch_type__desc_low": "- Dor ao realizar caminhadas longas ou ficar em pé, especialmente na área do arco ou calcanhar.\n- Mais propensão a cair ao caminhar ou correr.\n- Distribuição desigual do seu peso corporal levará a uma postura instável ao ficar em pé e o lado interno dos seus sapatos se desgastará mais rapidamente.\n\nRecomendação de tipo de sapato: Sapatos ou solas que têm alto suporte no seu arco que evitarão que você torça seu tornozelo. A dureza da sola deve ser de cerca de 40-60 graus, estruturada e estável, não muito macia. A largura dos sapatos deve ser flexível para que seu pé se mova confortavelmente. A parte do calcanhar precisa ser ajustada e confortável.",
    "foot_type__title": "Seu Tipo de Pé",
    "foot_type__egyptian": "Dedo Egípcio",
    "foot_type__summary_egyptian": "Os dedos diminuem em comprimento do dedão ao dedinho.",
    "foot_type__desc_egyptian": "Os pés da maioria dos homens asiáticos têm dedões longos e ossos dos dedos inclinados.<br>\n\nRecomendação de tipo de sapato: É melhor escolher sapatos com uma leve inclinação na ponta se você não quiser apertar seus dedos.<br> Você especialmente não é adequado para sapatos de bico fino. Como a maior parte do seu peso corporal cairá no seu dedão, você terá mais probabilidade de ter hálux valgo.",
    "foot_type__roman": "Dedo Romano",
    "foot_type__summary_roman": "Os três primeiros dedos têm o mesmo comprimento, enquanto os outros dois são mais curtos.",
    "foot_type__desc_roman": "Este formato de dedo é caracterizado pelos três primeiros dedos terem a mesma altura, com os outros dois diminuindo em comprimento. As pessoas que têm esse tipo de dedo são conhecidas por terem um formato corporal equilibrado, assim como a personalidade.\n\nRecomendação de tipo de sapato: Adequado para sapatos com um formato amplo para que todos os seus dedos tenham espaço e não fiquem pressionados uns contra os outros.",
    "foot_type__greek": "Dedo Grego",
    "foot_type__summary_greek": "O segundo dedo é mais proeminente que o restante, incluindo o dedão.",
    "foot_type__desc_greek": "Os dedos formam devido ao fato de que o segundo dedo é mais longo que o restante, e o comprimento dos outros diminui à medida que se aproximam do lado do pé. É chamado de pé grego porque os antigos gregos achavam atraente ter o dedo grego. Fato interessante: muitas estátuas antigas gregas e a Estátua da Liberdade têm dedos gregos.\n\nRecomendação de tipo de sapato: Recomenda-se usar sapatos de bico redondo, sapatos de bico oblíquo e sapatos que não pressionem os dedos. Como seu peso corporal cairá no seu segundo dedo, você é mais adequado para sapatos que têm amortecimento na parte dianteira do pé com suporte macio e flexível.",
    "foot_type__unknown": "Desconhecido",
    "foot_type__summary_unknown": "Resumo Desconhecido",
    "foot_type__desc_unknown": "Desc desconhecido"
  },
  "mobileScan": {
    "mobile_scan": "Escaneamento por Celular",
    "body_scanner": "Scanner Corporal",
    "data_processing": "Processando dados do escaneamento...",
    "comeback_later": "Por favor, volte em 5-10 minutos para revisar seu avatar 3D",
    "data_process_failed": "Incapaz de processar dados do escaneamento",
    "error_not_inscreen": "Seu corpo inteiro não foi capturado na tela",
    "error_messy_background": "O fundo está muito bagunçado",
    "device_unsupported": "Ops!<br>Seu dispositivo não suporta escaneamento 3D por celular",
    "need_faceid": "O escaneamento corporal 3D por celular só pode ser operado no iPhone X ou iPhones mais novos com Face ID",
    "scanner_name": "Escaneamento Corporal 3D por Celular",
    "begin_title": "Prepare-se para Escanear",
    "begin_info": "Use roupas justas e prenda seu cabelo para mostrar a parte de trás do seu pescoço",
    "start_tutorial": "Iniciar tutorial",
    "not_first": "Não é sua primeira vez aqui?",
    "skip_tutorial": "Pular tutorial",
    "vertical_info": "Posicione o telefone<br>verticalmente em uma<br>superfície plana",
    "inscreen_info": "Certifique-se de que<br>seu corpo inteiro<br>esteja capturado",
    "backoff_info": "Clique em próximo, volte<br>e fique na pose de escaneamento em 10 seg.",
    "spin_info": "Feche os dedos,<br>abra os braços e gire<br>em 360° dentro de 10 seg.",
    "check_title": "Prepare-se para Escanear",
    "check_info": "Por favor, confirme na<br>lista de verificação a seguir",
    "wear_tight": "Use roupas justas e prenda seu cabelo",
    "wipe_front": "Limpe a lente da câmera frontal",
    "volume_up": "Aumente o volume ao máximo",
    "next": "Próximo",
    "starting_in": "Iniciando em",
    "preview_info": "Por favor, confirme na<br>lista de verificação a seguir",
    "preview_inscreen": "Corpo inteiro capturado",
    "preview_arms_open": "Braços abertos",
    "preview_spin": "Gire 360°",
    "rescan": "Escanear novamente",
    "uploading": "Processando dados do escaneamento...<br>Não feche a janela",
    "uploading_done": "Análise completa!<br>Por favor, volte em 5-10 minutos para revisar seu avatar 3D",
    "finish_btn": "Concluir",
    "front_info": "Para a foto frontal, mantenha a pose em A e fique parado.",
    "side_info": "Para a foto de perfil, vire-se para a esquerda. Mantenha os braços próximos ao corpo e fique parado.",
    "qr_not_valid": "Código QR inválido",
    "qr_not_valid_desc": "Entre em contato com a loja para obter um novo código QR.",
    "back_to_home": "Voltar ao início",
    "privacy_info": "Escaneie com tranquilidade — assim que seu modelo 3D for criado, as fotos são excluídas permanentemente."
  },
  "mobileScan2": {
    "inscreen_front_info": "Certifique-se de que seu corpo inteiro está visível na tela, com braços e pernas ligeiramente afastados.",
    "inscreen_side_info": "Para a foto lateral, por favor, vire à esquerda. Mantenha os pés juntos e coloque as mãos contra a parte externa das coxas.",
    "inscreen_info": "Certifique-se de que seu corpo inteiro está visível na tela. Evite capturar a borda da mesa.",
    "trun_left_info": "Vire à esquerda, coloque as mãos contra a parte externa das coxas, mantenha os pés juntos."
  },
  "share": {
    "voucher_expired": "Sessão expirada.<br>Por favor, atualize a página.",
    "no_scan_data": "Nenhum resultado de digitalização encontrado."
  }
};
